import React, { useEffect } from "react";
import Header from "./components/Header";
import AOS from "aos";
import "aos/dist/aos.css";
import Form from "./components/Form";
import Booth from "./components/Booth";
import Gallery from "./components/Gallery";
import { ResponsiveCarousel } from "./components/Crousel";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);
  return (
    <div>
      <div className="max-w-[1440px] mx-auto">
        <Header />
        <Gallery />
        <Booth />
        <ResponsiveCarousel />
        <Form />
        <Footer />
      </div>
    </div>
  );
}

export default App;
